module.exports = __webpack_public_path__ + "static/autopal-mpg-d462b21fa1a047d0445a080f289c2b7b.png";